import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    actionButton: {
        display: 'inline-block',
        border: 'none',
        background: 'transparent',
        margin: '0',
        textDecoration: 'none',
        fontSize: '1rem',
        cursor: 'pointer',
        '&:disabled': { cursor: 'default' }
    },
    actionButtonText: {
        color: theme?.app?.applicationColors.fontDetailColor || '#4a4a50',
        fontSize: '13px',
        marginTop: '0.5rem'
    },
    actionButtonTextDisabled: {
        color: theme?.app?.applicationColors.disabledItemColor || '#c3c1c1',
        fontSize: '15px'
    },
    normalContainer: {
        display: 'flex',
        width: '75px',
        height: '75px',
        borderRadius: '50%',
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLighter || '#0096ff',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark || '#0a2241' }
    },
    actionButtonIcon: {
        height: '36px',
        width: '36px'
    },
    disabledContainer: {
        display: 'flex',
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF',
        borderRadius: '50%',
        border: `1px solid ${theme?.app?.applicationColors.disabledItemColor || '#c3c1c1'}`,
        color: theme?.app?.applicationColors.disabledItemColor || '#c3c1c1',
        alignItems: 'center',
        justifyContent: 'center',
        width: '75px',
        height: '75px'
    }
}));